import { LegalLayout } from "@/components/site/LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout eyebrow="Rechtliches" title="Impressum">
      <h2>Angaben gemäß § 5 DDG</h2>
      <p>
        DirektLab
        <br />
        Siemensstraße 27C
        <br />
        63165 Mühlheim am Main
        <br />
        Deutschland
      </p>

      <h2>Vertreten durch</h2>
      <p>Mandana Gholami, Geschäftsführer</p>

      <h2>Kontakt</h2>
      <p>
        Telefon:{" "}<a href="tel:+4915222825309">+49 152 22825309</a>
        <br />
        E-Mail:{" "}<a href="mailto:kontakt@direktlab.de">kontakt@direktlab.de</a>
      </p>

      <h2>Steuer-Identifikationsnummer</h2>
      <p>DE445502733</p>

      <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
      <p>
        Mandana Gholami
        <br />
        Siemensstraße 27C, 63165 Mühlheim am Main
      </p>

      <h2>Urheberrecht</h2>
      <p>
        Die durch den Seitenbetreiber erstellten Inhalte und Werke auf dieser
        Webseite unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers.
      </p>
    </LegalLayout>
  );
}
